import React, {PropTypes} from 'react';
import {Map} from 'immutable';
import Component from 'react-pure-render/component';
import {Col, Row} from 'react-bootstrap/lib/';
import {
  nodeToJs,
  composeItemData,
  createCheckbox,
  numCheckboxesChecked,
  setDisabled,
  maybeCreateEmptyObject
} from './utils';
import objectAssign from 'object-assign';

export default class CheckboxesGroup extends Component {
  static propTypes = {
    updateAction: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired,
    heading: PropTypes.string.isRequired,
    note: PropTypes.string,
    field: PropTypes.string.isRequired,
    value: PropTypes.object.isRequired,
    maxSelected: PropTypes.number,
    otherField: PropTypes.string,
    otherFieldName: PropTypes.string,
    otherFieldPlaceholder: PropTypes.string,
    xs: PropTypes.number.isRequired,
    sm: PropTypes.number,
    inputsXs: PropTypes.number,
    headingXs: PropTypes.number,
    disabled: PropTypes.bool
  }
  // Todo: Similar method is in Dropdown class, abstract it.
  isOtherFieldEnabled(value) {
    const {otherField} = this.props;

    if (value !== null && value !== undefined) {
      if ('string' === typeof otherField && otherField.length > 1) {
        return value[otherField] === true;
      }
    }

    return false;
  }

  onCheckboxChange(event) {
    const {
      updateAction,
      value,
      field,
      otherField,
      otherFieldName,
      maxSelected
    } = this.props;
    const {target: {name, checked}} = event;
    // Currently value is a plain object, but in future refactoring
    // we should switch to immutables. So operations inside of this function
    // are performed on Map, but then converted back to JS.
    let result = new Map(maybeCreateEmptyObject(value));
    // const result = objectAssign({}, value);
    const currentChecboxState = result.get(name);

    if (maxSelected === undefined || maxSelected === null) {
      result = result.set(name, checked);
    } else if (numCheckboxesChecked(result) < maxSelected) {
      result = result.set(name, checked);
    } else if (currentChecboxState === true) {
      result = result.set(name, false);
    }

    if (name === otherField && !checked) {
      result = result.set(otherFieldName, '');
    }

    updateAction({target: {name: field, value: result.toJS()}});
  }

  onInputChange(event) {
    const {updateAction, value, field, otherFieldName} = this.props;
    const {target: {value: inputValue}} = event;
    const result = objectAssign({}, value);

    result[otherFieldName] = inputValue;

    updateAction({target: {name: field, value: result}});
  }

  render() {
    const {
      children,
      heading,
      note,
      value,
      maxSelected,
      otherFieldName,
      otherFieldPlaceholder,
      xs,
      sm,
      headingXs = 12,
      inputsXs = 12
    } = this.props;
    let disabled = false;

    const otherFieldEnabled = this.isOtherFieldEnabled(value);
    const otherFieldValue = value[otherFieldName];

    if ('number' === typeof maxSelected) {
      disabled = numCheckboxesChecked(value) >= maxSelected;
    }

    if (value === null || value === undefined) {
      throw new Error(`Checkboxes:error missing value`);
    }

    const items = children
      .map(nodeToJs)
      .map(composeItemData({action: this.onCheckboxChange.bind(this), value}));


    const checkboxes = items
      .map(setDisabled(disabled))
      .map(createCheckbox);

    return (
      <Col xs={xs} sm={sm}>
        <Row>
          {heading && <Col xs={headingXs}> <h3>{heading}</h3> </Col>}
          {note && <Col className="group-note" xs={headingXs}>{note}</Col>}
          <Col xs={inputsXs} className="form-inline">
            {checkboxes}
            {
              otherFieldEnabled &&
              <input
                className="form-control"
                onChange={::this.onInputChange}
                placeholder={otherFieldPlaceholder}
                type="text"
                value={otherFieldValue}
                />
            }
          </Col>
        </Row>
      </Col>
    );
  }
}
